import { useSelector } from "react-redux";
import { useAppDispatch } from "store/hooks";
import ProfileContainer from "../userProfile/ProfileView";
import ModalWindow from "../common/modalWindow/ModalWindow";

import "./UserProfileWindowContainer.scss";
import { selectUserProfileWindowOpen } from "./redux/selectors";
import { closeUserProfileWindow } from "./redux/userProfileWindowSlice";
import { styles } from "./styles";

const UserProfileWindowContainer = () => {
  const isWindowOpen = useSelector(selectUserProfileWindowOpen);
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(closeUserProfileWindow());
  };

  return (
    <ModalWindow
      onClose={handleClose}
      maxWidth="xl"
      className="profile-modal"
      open={isWindowOpen}
      sx={styles.header}
    >
      <ProfileContainer />
    </ModalWindow>
  );
};

export default UserProfileWindowContainer;
